export default __webpack_public_path__ + "static/media/Belt of the Clay.a4054ee2.jpg";